import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase'
import { LearningCourseRepository } from '@/core/infrastructure/repositories/learning/course/LearningCourseRepository'
import { FetchAllLearningCoursesUseCase } from '@/core/useCases/learning/course/FetchAllLearningCoursesUseCase'
import { FetchLearningCourseUseCase } from '@/core/useCases/learning/course/FetchLearningCourseUseCase'
import { CreateLearningCourseUseCase } from '@/core/useCases/learning/course/CreateLearningCourseUseCase.ts'
import { UpdateLearningCourseStatusUseCase } from '@/core/useCases/learning/course/UpdateLearningCourseStatusUseCase.ts'
import { LearningModuleRepository } from '@/core/infrastructure/repositories/learning/module/LearningModuleRepository.ts'
import { UpdateLearningModuleStatusUseCase } from '@/core/useCases/learning/module/UpdateLearningModuleStatusUseCase.ts'
import { FetchAllLearningModulesUseCase } from '@/core/useCases/learning/module/FetchAllLearningModulesUseCase.ts'
import { FetchLearningModuleUseCase } from '@/core/useCases/learning/module/FetchLearningModuleUseCase.ts'
import { CreateLearningModuleUseCase } from '@/core/useCases/learning/module/CreateLearningModuleUseCase.ts'
import { UpdateLearningModuleUseCase } from '@/core/useCases/learning/module/UpdateLearningModuleUseCase.ts'
import { LearningGrainRepository } from '@/core/infrastructure/repositories/learning/grain/LearningGrainRepository.ts'
import { FetchLearningGrainUseCase } from '@/core/useCases/learning/grain/FetchLearningGrainUseCase.ts'
import { FetchAllLearningGrainsUseCase } from '@/core/useCases/learning/grain/FetchAllLearningGrainsUseCase.ts'
import { UpdateLearningGrainStatusUseCase } from '@/core/useCases/learning/grain/UpdateLearningGrainStatusUseCase.ts'
import { UpdateLearningGrainUseCase } from '@/core/useCases/learning/grain/UpdateLearningGrainUseCase.ts'
import { CreateLearningGrainUseCase } from '@/core/useCases/learning/grain/CreateLearningGrainUseCase.ts'
import { UploadLearningSupportFileUseCase } from '@/core/useCases/learning/support/UploadLearningSupportFileUseCase.ts'

export class LearningModule extends ModuleBase {
  initialize(): void {
    this.initializeCourse()
    this.initializeModule()
    this.initializeGrain()
  }

  private initializeCourse(): void {
    const learningCourseRepository = new LearningCourseRepository()

    this.registerRepository(LearningCourseRepository, learningCourseRepository)

    const fetchAllLearningCoursesUseCase = new FetchAllLearningCoursesUseCase(
      learningCourseRepository
    )
    const fetchLearningCourseUseCase = new FetchLearningCourseUseCase(learningCourseRepository)
    const createLearningCourseUseCase = new CreateLearningCourseUseCase(learningCourseRepository)
    const updateLearningCourseStatusUseCase = new UpdateLearningCourseStatusUseCase(
      learningCourseRepository
    )

    this.registerUseCase(FetchAllLearningCoursesUseCase, fetchAllLearningCoursesUseCase)
    this.registerUseCase(FetchLearningCourseUseCase, fetchLearningCourseUseCase)
    this.registerUseCase(CreateLearningCourseUseCase, createLearningCourseUseCase)
    this.registerUseCase(UpdateLearningCourseStatusUseCase, updateLearningCourseStatusUseCase)
  }

  private initializeModule(): void {
    const learningModuleRepository = new LearningModuleRepository()

    this.registerRepository(LearningModuleRepository, learningModuleRepository)

    const fetchAllLearningModulesUseCase = new FetchAllLearningModulesUseCase(
      learningModuleRepository
    )
    const fetchLearningModuleUseCase = new FetchLearningModuleUseCase(learningModuleRepository)
    const createLearningModuleUseCase = new CreateLearningModuleUseCase(learningModuleRepository)
    const updateLearningModuleUseCase = new UpdateLearningModuleUseCase(learningModuleRepository)
    const updateLearningModuleStatusUseCase = new UpdateLearningModuleStatusUseCase(
      learningModuleRepository
    )

    this.registerUseCase(FetchAllLearningModulesUseCase, fetchAllLearningModulesUseCase)
    this.registerUseCase(FetchLearningModuleUseCase, fetchLearningModuleUseCase)
    this.registerUseCase(CreateLearningModuleUseCase, createLearningModuleUseCase)
    this.registerUseCase(UpdateLearningModuleUseCase, updateLearningModuleUseCase)
    this.registerUseCase(UpdateLearningModuleStatusUseCase, updateLearningModuleStatusUseCase)
  }

  private initializeGrain(): void {
    const learningGrainRepository = new LearningGrainRepository()
    this.registerRepository(LearningGrainRepository, learningGrainRepository)

    const fetchLearningGrainUseCase = new FetchLearningGrainUseCase(learningGrainRepository)
    const fetchAllLearningGrainsUseCase = new FetchAllLearningGrainsUseCase(learningGrainRepository)
    const updateLearningGrainUseCase = new UpdateLearningGrainUseCase(learningGrainRepository)
    const createLearningGrainUseCase = new CreateLearningGrainUseCase(learningGrainRepository)
    const uploadLearningSupportFileUseCase = new UploadLearningSupportFileUseCase(
      learningGrainRepository
    )
    const updateLearningGrainStatusUseCase = new UpdateLearningGrainStatusUseCase(
      learningGrainRepository
    )

    this.registerUseCase(FetchLearningGrainUseCase, fetchLearningGrainUseCase)
    this.registerUseCase(FetchAllLearningGrainsUseCase, fetchAllLearningGrainsUseCase)
    this.registerUseCase(UpdateLearningGrainUseCase, updateLearningGrainUseCase)
    this.registerUseCase(CreateLearningGrainUseCase, createLearningGrainUseCase)
    this.registerUseCase(UpdateLearningGrainStatusUseCase, updateLearningGrainStatusUseCase)
    this.registerUseCase(UploadLearningSupportFileUseCase, uploadLearningSupportFileUseCase)
  }
}
